import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbsComponent } from 'components/breadcrumbs/breadcrumbs.component';
import { ApiService } from 'services/api.service';
import { Breadcrumb } from 'types/breadcrumb.interface';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { StructuralUnitComponent } from 'components/structural-unit/structural-unit.component';
import { ToastService } from 'services/toast.service';
import { StructuralUnitCard, StructuralUnitListItem, UpdateStructuralUnitRequest } from 'types/structural-unit.interface';

@Component({
  selector: 'app-structural-unit-page',
  standalone: true,
  imports: [TranslateModule, BreadcrumbsComponent, SpinnerComponent, StructuralUnitComponent],
  templateUrl: './structural-unit-page.component.html',
  styleUrl: './structural-unit-page.component.scss'
})
export class StructuralUnitPageComponent {
  breadcrumbs: Breadcrumb[] = [
    {
      title: 'components.breadcrumbs.admin',
      url: ''
    },
    {
      title: 'components.breadcrumbs.departments',
      url: '/strukturvienibas'
    }
  ];

  structuralUnits: StructuralUnitListItem[] = [];

  isLoading: boolean = true;
  isCrudLoading: boolean = false;

  constructor(
    private apiService: ApiService,
    private toastService: ToastService
  ) {
    this.loadList();
  }

  editStructuralUnit(structuralUnit: StructuralUnitCard) {
    const args: UpdateStructuralUnitRequest = {
      name: structuralUnit.name,
      code: structuralUnit.code || '',
      phone: structuralUnit.phone,
      email: structuralUnit.email,
      address: structuralUnit.address,
      applicationEmail: structuralUnit.applicationEmail,
      isDefaultStructureForIncomingDocuments: structuralUnit.isDefaultStructureForIncomingDocuments || false
    };
    this.isCrudLoading = true;

    this.apiService.editStructuralUnit(structuralUnit.id!, args).subscribe(
      () => {
        this.apiService.getStructuralUnits().subscribe((data: any) => {
          this.structuralUnits = Array.isArray(data) ? data : (data.list ?? []);
          this.isCrudLoading = false;
          this.toastService.showSuccess('editStructuralUnitSuccess', '', { shouldTranslate: true });
        });
      },
      (error: any) => {
        this.isCrudLoading = false;
        this.toastService.showRequestError();
        console.error(error);
      }
    );
  }

  private loadList(): void {
    this.apiService.getStructuralUnits().subscribe((data: any) => {
      this.structuralUnits = Array.isArray(data) ? data : (data.list ?? []);
      this.isLoading = false;
      this.isCrudLoading = false;
    });
  }
}
